<template>
  <div :id="`${id}_cont`" class="form-group pb-2" v-if="showContent">
    <template v-if="!editMode">
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <label v-if="title" :for="id" class="title">{{ title }}<span v-if="maxText" class="small-text"> ( Límite de {{
          maxText }} caracteres.)</span></label>
          <template v-if="moreInfo" >
              <p :title="moreInfoText" class="m-0">
                  <i class="ri-information-2-line"></i>
              </p>           
          </template>
          <p class="invalid-feedback required ps-2" v-if="asterisk"> * </p>
        </div>
        <template v-if="!disableValidation && (feedback === 'invalid' || feedback === 'valid')">
            <p v-if="feedback === 'invalid'" class="invalid-feedback">
                {{ errorMsg }}
            </p>
            <p v-else-if="feedback === 'valid'" class="valid-feedback">
                {{ validMsg }}
            </p>
        </template>
        <template v-else-if="isRequired">
            <p class="invalid-feedback required">
                Dato obligatorio
            </p>
        </template>
        <template v-else-if="!isRequired && showRequired">
            <p class="invalid-feedback optional">
                Dato opcional
            </p>
        </template>
      </div>
    </template>
    <template v-else-if="editMode">
      <div class="d-flex">
        <label v-if="title" :for="id" class="title">{{ title }}</label>
        <template v-if="isRequired && !errorMsgForm && editMode">
          <p class="invalid-feedback required ms-1">*</p>
        </template>
      </div>
    </template>
    <textarea :id="id" class="form-control" rows="5" :placeholder="placeholder" :value="modelValue" :required=isRequired
      :maxlength="maxText !== '' ? parseInt(maxText) : null" :readonly="readonly" :editMode="editMode" @change="handleChange($event.target.value)"></textarea>
  </div>
  <!-- Loading -->
  <div :id="`${id}_cont`" v-else>
    <div class="form-group pb-2">
      <label v-if="title" class="title placeholder-glow col-3">
        <span class="placeholder col-12"></span>
      </label>
      <div class="placeholder-glow">
        <textarea :id="id" class="form-control placeholder" rows="5" :value="modelValue"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VsudTextarea",
  props: {
    id: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Ingrese su texto aquí"
    },
    errorMsg: {
      type: String,
      default: 'Valor incorrecto o nulo',
    },
    validMsg: {
      type: String,
      default: 'Completado correctamente',
    },
    maxText: {
      type: String,
      default: "",
    },
    isRequired: Boolean,
    disableValidation: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      default: " "
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    showRequired: {
        type: Boolean,
        default: true,
    },
    moreInfo: {
      type: Boolean,
      default: false,
    },
    moreInfoText: {
      type: String,
    },
    asterisk: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showContent: false,
      minLoadTime: 1500,
      loadStart: null,
      feedback: 'invalid',
    };
  },
  mounted() {
    this.loadStart = Date.now();
    window.addEventListener("load", this.onLoad);
    setTimeout(() => {
      this.showContent = true;
    }, this.minLoadTime);

    if (this.modelValue == "") {
      this.feedback = "null";
    }
  },
  beforeUnmount() {
    window.removeEventListener("load", this.onLoad);
  },
  watch: {
    modelValue(newVal) {
      if (newVal == "" && this.isRequired) {
        this.feedback = "invalid";
      } else if (newVal && newVal != "" && this.maxText && newVal.length > Number(this.maxText)) {
        this.feedback = "invalid";
      } else {
        this.feedback = "valid";
      }
      this.$emit("feedback", this.feedback);
    },
  },
  methods: {
    onLoad() {
      const loadTime = Date.now() - this.loadStart;
      if (loadTime >= this.minLoadTime) {
        this.showContent = true;
      } else {
        setTimeout(() => {
          this.showContent = true;
        }, this.minLoadTime - loadTime);
      }
    },
    handleChange(newValue) {
      this.$emit('update:modelValue', newValue);
      this.$nextTick(() => {
          if (newValue === "") {
              this.feedback = "invalid";
          } else {
              this.feedback = "valid";
          }
          this.$emit('feedback', this.feedback);
      });
    }
  },
};
</script>

<style scoped>
.title {
  color: var(--black);
  font-size: 0.9rem;
  font-weight: 500;
}

.small-text {
  font-size: 0.8rem;
  color: var(--gray-text);
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus,
.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
  box-shadow: none;
}

.optional {
  color: var(--gray-text);
}
.ri-information-2-line {
    color: var(--blue);
    position: relative;
    bottom: 3px;
    padding-left: 0.3rem;
    cursor: pointer;
}
</style>
<style>
.gray-text-area.form-group{
  margin-bottom: 0;
}
.gray-text-area textarea.form-control{
  background-color: var(--hover-gray);
}
</style>